import { inject, Injectable } from '@angular/core';
import { ApiService } from '@app/gateway';
import { MensagemModel } from '../models';
import { StoreService } from './store.service';

@Injectable({ providedIn: 'root' })
export class MensagemService {
  private readonly accountService = inject(StoreService);
  private readonly apiService = inject(ApiService);

  public async mensagemPedido(data: MensagemModel): Promise<any> {
    try {
      const storeName = this.accountService.getStoreName();
      const path: string = `/enviar/${storeName}`;
      const mensagem = true;
      return await this.apiService.post({ path, data, mensagem });
    } catch (e: any) {
      console.error("Falha ao enviar mensagem (Instância não encontrada ou erro de API):", e.message);
      return null;
    }
  }

  public async mensagemLogin(phone: string): Promise<any> {
    try {
      const storeName = this.accountService.getStoreName();
      const path: string = `/validar/${storeName}/${phone}`;
      const mensagem = true;
      return await this.apiService.get({ path, mensagem });
    } catch (e: any) {
      throw new Error(e.message);
    }
  }

  public async mensagemVerificar(uuid: string, senha: string): Promise<any> {
    try {
      const path: string = `/validar/senha/${uuid}/${senha}`;
      const mensagem = true;
      return await this.apiService.get({ path, mensagem });
    } catch (e: any) {
      throw new Error(e.message);
    }
  }

  formatPhonePesquisa(phone: string): string {
    // Remove todos os caracteres que não são dígitos
    const cleaned = phone.replace(/\D/g, '');

    // Verifica se o número tem 11 dígitos (DDD + 9 dígitos)
    if (cleaned.length === 11) {
      const ddd = cleaned.slice(0, 2);
      const part1 = cleaned.slice(2, 7);
      const part2 = cleaned.slice(7, 11);
      return `(${ddd}) ${part1}-${part2}`;
    }

    // Retorna o número original se não tiver 11 dígitos
    return phone;
  }
}
